export interface EventData {
  users: User[];
  id: string;
  event_name: string;
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
  availability: { [key: string]: string[] };
  created_at: string;
  updated_at: string;
}

export interface User {
  id: string;
  name: string;
}

export interface State {
  eventData: EventData;
  userID: string;
  currentHover: string[];
}

export const state: State = {
  eventData: <EventData>{},
  userID: "",
  currentHover: [],
};
